import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../components/layout';
import SEO from '../components/seo';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Layout mdxType="Layout">
      <SEO title="Component Library" mdxType="SEO" />
      <h1>{`Component Library`}</h1>
      <p>{`We maintain a component library based on `}<a parentName="p" {...{
          "href": "https://designsystem.digital.gov/",
          "title": "USWDS homepage"
        }}>{`USWDS`}</a>{` that can be used across many different projects.
`}<a parentName="p" {...{
          "href": "https://civicactions.github.io/FE-component-library/"
        }}>{`https://civicactions.github.io/FE-component-library/`}</a></p>
      <p>{`We encourage you to contribute any useful components that you may make while working on a project. For more information see the project repo.
`}<a parentName="p" {...{
          "href": "https://github.com/CivicActions/FE-component-library"
        }}>{`https://github.com/CivicActions/FE-component-library`}</a></p>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      